import { IS_VALID, IS_ACTIVE } from '/source/js/base/baseClasses';
import { isRequiredField } from '/source/_patterns/01-components/checkout/checkout-shared';
export const FORM_LABEL = '.form-label';
export const FORM_GROUP = '.form-group';
export const FORM_BLOCK = '.form-block';
export const FORM_INPUT = '.form-input';

export function customValidationMethods() {
    $.validator.addMethod('valueNotEquals', function(value, element, arg) {
        return arg !== value;
    }, function(params, element) {
        return $(element).attr('data-msg-required');
    });
    $.validator.addMethod('equalToIgnoreCase', function(value, element, param) {
        return this.optional(element) || (value.toLowerCase() === $(param).val().toLowerCase());
    }, 'Must enter the same password');
    $.validator.addMethod('equalToCustom', function(value, element, param) {
        return this.optional(element) || (value === $(param).val());
    }, function(params, element) {
        return $(element).data('msg-custom');
    });
    $.validator.addMethod('notEqualToCustom', function(value, element, param) {
        return this.optional(element) || (value !== $(param).val());
    }, function(params, element) {
        return $(element).data('msg-custom');
    });
    $.validator.setDefaults({
        onkeyup: false
    });
    $.validator.addMethod('customRegex', function(value, element, param) {
        return this.optional(element) || value.match(param);
    }, function(params, element) {
        return $(element).data('msg-custom');
    });
    $.validator.addMethod('notContain', function(value, element, param) {
        return this.optional(element) || value.indexOf(param) === -1;
    }, function(params, element) {
        return $(element).data('msg-custom');
    });
    $.validator.addMethod('isValidFormat', function(value, element, param) {
        const requiredFlag = isRequiredField(this, element);
        const shouldProcessNumbers = $(element).data('numbers-only');
        let processedValue = value;
        if(shouldProcessNumbers && value) {
            // Trim the value first
            processedValue = value.trim();
            // Remove all non-numeric characters
            processedValue = processedValue.replace(/\D/g, '');
        }
        const regex = new RegExp(element.pattern);
        const result = shouldProcessNumbers === true ? regex.test(processedValue) : regex.test(value);
        return this.optional(element) || !requiredFlag || result;
    }, function (params, element) {
        let grandParent = $(element).closest('.form-group.form-group--half');
        grandParent.addClass('pb-3');
        return $(element).data('msg-format');
    });
    $.validator.addMethod('isValidPhoneNumber', function(value, element, param) {
        let isDuplicatePhone = $(element).attr('data-duplicate-phone');
        let isEnrollmentForm = $(element).attr('data-is-enrollment');
        let currentPhoneNumber = $(element).val();
        let prevPhoneNumber = $(element).attr('data-prev-phone-number');
        let result = false;
        if(isDuplicatePhone !== undefined && isEnrollmentForm !== undefined && prevPhoneNumber !== currentPhoneNumber) {
            result = true;
        }
        if(prevPhoneNumber === undefined && isDuplicatePhone === undefined && isEnrollmentForm === undefined) {
            result = true;
        }
        return this.optional(element) || result;
    }, function(params, element) {
        let grandParent = $(element).closest('.form-group.form-group--half');
        grandParent.addClass('pb-3');
        return $(element).data('duplicate-phone-number-msg');
    });
    $.validator.addMethod('patternMatches', function(value, element, param) {
        const regex = new RegExp(element.pattern);
        const result = regex.test(value);
        return this.optional(element) || result;
    }, function(params, element) {
        return $(element).data('msg-required');
    });
    $.validator.addMethod('addressFieldHasInvalidChars', function(value, element, param) {
        let invalidChars = $(element).data('invalidchars');
        if(!invalidChars) return true;
        const requiredFlag = isRequiredField(this, element);
        let invalidCharsRegex = new RegExp(invalidChars, 'g');
        let result = invalidCharsRegex.test(value);
        return this.optional(element) || (!requiredFlag && value.length === 0) || !result;
    }, function(params, element) {
        return $(element).data('msg-invalidchars');
    });
    $.validator.addMethod('checkForInvalidChars', function(value, element) {
        let invalidChars = $(element).data('invalidchars');
        if(!invalidChars) return true;
        let invalidCharsRegex = new RegExp(invalidChars, 'g');
        let result = invalidCharsRegex.test(value);
        return this.optional(element) || !result;
    }, function(params, element) {
        return $(element).data('msg-invalidchars');
    });
}

export let validation = {
    onfocusout: function(element) {
        this.element(element);
    },
    highlight: function(element) {
        $(element).parent().addClass('is--error');
    },
    unhighlight: function(element) {
        $(element).parent().removeClass('is--error');
    },
    errorElement: 'span',
    rules: {
        verifyCVV: {
            minlength: 3,
            maxlength: 4,
            required: true
        },
        verifyCVVSubscription: {
            minlength: 3,
            maxlength: 4,
            required: true
        },
        firstName: {
            required: true
        },
        lastName: {
            required: true
        },
        email: {
            email: true,
            required: true
        },
        address1Input: {
            required: true
        },
        address2Input: {
            required: false
        },
        address3Input: {
            required: false
        },
        address4Input: {
            required: '#address4Input'
        },
        cityInput: {
            required: true
        },
        language: {
            required: true,
            valueNotEquals: 'default'
        },
        zipCodeInput: {
            required: true
        },
        phone: {
            required: true,
            isValidPhoneNumber: true
        },
        communications: {
            required: true
        }
    }
};

export function passwordCheck() {
    let $passwordLetter = $('.form__password-letter');
    let $passwordNumber = $('.form__password-number');
    let $passwordLength = $('.form__password-length');
    let $passwordSpaces = $('.form__password-spaces');
    let $passwordSpecial = $('.form__password-special');
    let $passwordUser = $('.form__password-user');
    let $togglePassword = $('.toggle-password');

    $('#password').keyup(function() {
        let $this = $(this);
        let $usernameInput = $('#username');
        let passwordVal = $this.val();
        let usernameVal = $usernameInput.val();

        let passwordAlpha = /[A-Za-z]/g;
        if(passwordVal.match(passwordAlpha)) {
            let passwordAlphaUpper = /[A-Z]/g;
            let passwordAlphaLower = /[a-z]/g;
            if(passwordVal.match(passwordAlphaUpper) && passwordVal.match(passwordAlphaLower)) {
                $passwordLetter.addClass(IS_VALID);
            } else {
                $passwordLetter.removeClass(IS_VALID);
            }
        } else {
            $passwordLetter.removeClass(IS_VALID);
        }

        let passwordNumber = /[0-9]/g;
        if(passwordVal.match(passwordNumber)) {
            $passwordNumber.addClass(IS_VALID);
        } else {
            $passwordNumber.removeClass(IS_VALID);
        }

        let specialCharacters = /[!@\$%\^&\+\-=,\._]/g; //eslint-disable-line
        if(passwordVal.match(specialCharacters)) {
            $passwordSpecial.addClass(IS_VALID);
        } else {
            $passwordSpecial.removeClass(IS_VALID);
        }

        if(passwordVal.match(/[ ]/g)) {
            $passwordSpaces.removeClass(IS_VALID);
        } else {
            $passwordSpaces.addClass(IS_VALID);
        }

        if(passwordVal.length >= 8 && passwordVal.length <= 20) {
            $passwordLength.addClass(IS_VALID);
        } else {
            $passwordLength.removeClass(IS_VALID);
        }

        if(!passwordVal.match(usernameVal)) {
            $passwordUser.addClass(IS_VALID);
        } else {
            $passwordUser.removeClass(IS_VALID);
        }
    });

    $('#username').keyup(function() {
        let usernameVal = $(this).val();
        let passwordVal = $('#password').val();

        if(!passwordVal.match(usernameVal)) {
            $passwordUser.addClass(IS_VALID);
        } else {
            $passwordUser.removeClass(IS_VALID);
        }
    });

    $togglePassword.on('click', function(e) {
        e.preventDefault();
        let $this = $(this);
        $this.children('.password-icon').toggleClass('d-none');
        $this.siblings('input').attr('type', function(index, attr) {
            return attr === 'password' ? 'text' : 'password';
        });
    });
}

export function trimFields() {
    let $this = $(this);
    $this.val($.trim($this.val()));
}

export function validatePassword() {
    let $pwList = $('.form__password-regex-list');
    if($pwList.length < 1) return true;

    return $pwList.find(`li:not(.${IS_VALID})`).length < 1;
}

export function validateForm($form, config) {
    let newValidator = new $.validator(config, $form[0]); // eslint-disable-line
    $.data($form[0], 'validator', newValidator);
    let validator = $form.validate(config);
    return validator.form() && validatePassword();
}

export function validateElement(selector, $form, config) {
    let newValidator = new $.validator(config, $form[0]); // eslint-disable-line
    $.data($form[0], 'validator', newValidator);
    let validator = $form.validate(config);
    return validator.element(selector);
}

function formInput($item) {
    if($item.currentTarget) {
        $item = $($item.currentTarget);
    }

    if(!$item.val()) {
        $item.removeClass(IS_ACTIVE);
        $item.siblings(FORM_LABEL).removeClass(IS_ACTIVE);
    } else {
        $item.addClass(IS_ACTIVE);
        $item.siblings(FORM_LABEL).addClass(IS_ACTIVE);
    }
}

function checkAllFormInput() {
    $(FORM_INPUT).each(function(index, item) {
        formInput($(item));
    });
}

$(function() {
    $('body').on('input', FORM_INPUT, formInput);
    customValidationMethods();
    checkAllFormInput();
});
